  export const formatValue = (val) => {
    const num = parseFloat(val);
    if (isNaN(num)) return "Invalid Value";

    // round to 1 decimal
    const rounded = Math.round(num * 10) / 10;

    // remove unnecessary .0
    return Number.isInteger(rounded) ? rounded : rounded;
  };

  export const normalizeTrimAndLowercase = (str) =>
  str?.toString().trim().toLowerCase().replace(/\s+/g, " ");

  export const cleanHtml = (html) => {
    if (!html) return "";
    return String(html).replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();
  };